import { Code as ChakraCode } from "@chakra-ui/react"

export const Code = ChakraCode

/**
 * @typedef {import("@chakra-ui/react").CodeProps} CodeProps
 */
